export var LiveChatAccountAccess;
(function (LiveChatAccountAccess) {
    LiveChatAccountAccess["Blocked"] = "blocked";
    LiveChatAccountAccess["Granted"] = "granted";
    LiveChatAccountAccess["GrantedAfterUpgrade"] = "granted-after-upgrade";
})(LiveChatAccountAccess || (LiveChatAccountAccess = {}));
